<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconComment"/>
          </span>
          <div>
            <h1 class="pl-card__title">نظرات کاربران</h1>
            <p class="pl-card__sub" v-if="product_title">{{ product_title }}</p>
            <p class="pl-card__sub" v-else>مدیریت دیدگاه‌های محصولات</p>
          </div>
        </div>
        <div class="pl-toolbar" v-if="product_title != ''">
          <button type="button" class="pl-btn pl-btn--primary" @click="import_comment_modal = true">
            <CIcon name="iconPlus"/>
            <span>دریافت از سایت دیگر</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CTabs>
          <CTab :title="'منتشر شده' + ' (' + items_active.length + ')'">
            <CDataTableFixed
              class="pl-table"
              :items="items_active"
              :fields="fields"
              :items-per-page="20"
              hover
              sorter
              pagination
              :noItemsView="{ noItems: 'دیدگاهی یافت نشد' }"
            >
              <template #no-items-view>
                <div class="pl-empty">
                  <span class="pl-empty__icon" aria-hidden="true">
                    <CIcon name="iconComment"/>
                  </span>
                  <p class="pl-empty__title">دیدگاه منتشرشده‌ای یافت نشد</p>
                </div>
              </template>

              <template #row="{ item }">
                <td>
                  <span class="pl-muted">{{ item.id }}</span>
                </td>
              </template>

              <template #کاربر="{ item }">
                <td>
                  <span class="pl-name">{{ item.name }}</span>
                </td>
              </template>

              <template #product="{ item }">
                <td>
                  <span class="pl-muted">{{ item.product.title.title }}</span>
                </td>
              </template>

              <template #دیدگاه="{ item }">
                <td>
                  <span class="pl-muted">{{ item.summary }}</span>
                </td>
              </template>

              <template #تاریخ="{ item }">
                <td>
                  <span class="pl-muted">{{ get_date_time(item.created_at) }}</span>
                </td>
              </template>

              <template #عملیات="{ item }">
                <td class="pl-ops-cell">
                  <div class="pl-ops">
                    <button
                      type="button"
                      class="pl-btn pl-btn--sm pl-btn--ghost"
                      @click="change_status(item, '0')"
                    >
                      عدم انتشار
                    </button>
                    <button
                      type="button"
                      class="pl-icon-btn pl-icon-btn--danger"
                      title="حذف"
                      @click="change_status(item, '2')"
                    >
                      <CIcon name="iconTrash"/>
                    </button>
                    <button
                      type="button"
                      class="pl-icon-btn pl-icon-btn--info"
                      title="پاسخ"
                      @click="reply_comment_modal = true, reply_comment_id = item.id"
                    >
                      <CIcon name="iconComment"/>
                    </button>
                  </div>
                </td>
              </template>
            </CDataTableFixed>
          </CTab>

          <CTab :title="'منتشر نشده' + ' (' + items_deactive.length + ')'">
            <CDataTableFixed
              class="pl-table"
              :items="items_deactive"
              :fields="fields"
              :items-per-page="20"
              hover
              sorter
              pagination
              :noItemsView="{ noItems: 'دیدگاهی یافت نشد' }"
            >
              <template #no-items-view>
                <div class="pl-empty">
                  <span class="pl-empty__icon" aria-hidden="true">
                    <CIcon name="iconComment"/>
                  </span>
                  <p class="pl-empty__title">دیدگاه در انتظار انتشاری یافت نشد</p>
                </div>
              </template>

              <template #row="{ item }">
                <td>
                  <span class="pl-muted">{{ item.id }}</span>
                </td>
              </template>

              <template #کاربر="{ item }">
                <td>
                  <span class="pl-name">{{ item.name }}</span>
                </td>
              </template>

              <template #product="{ item }">
                <td>
                  <span class="pl-muted">{{ item.product.title.title }}</span>
                </td>
              </template>

              <template #دیدگاه="{ item }">
                <td>
                  <span class="pl-muted">{{ item.summary }}</span>
                </td>
              </template>

              <template #تاریخ="{ item }">
                <td>
                  <span class="pl-muted">{{ get_date_time(item.created_at) }}</span>
                </td>
              </template>

              <template #عملیات="{ item }">
                <td class="pl-ops-cell">
                  <div class="pl-ops">
                    <button
                      type="button"
                      class="pl-btn pl-btn--sm pl-btn--primary"
                      @click="change_status(item, '1')"
                    >
                      <CIcon name="iconCheck"/>
                      <span>انتشار</span>
                    </button>
                    <button
                      type="button"
                      class="pl-icon-btn pl-icon-btn--danger"
                      title="حذف"
                      @click="change_status(item, '2')"
                    >
                      <CIcon name="iconTrash"/>
                    </button>
                  </div>
                </td>
              </template>
            </CDataTableFixed>
          </CTab>

          <CTab :title="'حذف شده' + ' (' + items_deleted.length + ')'">
            <CDataTableFixed
              class="pl-table"
              :items="items_deleted"
              :fields="fields"
              :items-per-page="20"
              hover
              sorter
              pagination
              :noItemsView="{ noItems: 'دیدگاهی یافت نشد' }"
            >
              <template #no-items-view>
                <div class="pl-empty">
                  <span class="pl-empty__icon" aria-hidden="true">
                    <CIcon name="iconComment"/>
                  </span>
                  <p class="pl-empty__title">دیدگاه حذف‌شده‌ای یافت نشد</p>
                </div>
              </template>

              <template #row="{ item }">
                <td>
                  <span class="pl-muted">{{ item.id }}</span>
                </td>
              </template>

              <template #کاربر="{ item }">
                <td>
                  <span class="pl-name">{{ item.name }}</span>
                </td>
              </template>

              <template #product="{ item }">
                <td>
                  <span class="pl-muted">{{ item.product.title.title }}</span>
                </td>
              </template>

              <template #دیدگاه="{ item }">
                <td>
                  <span class="pl-muted">{{ item.summary }}</span>
                </td>
              </template>

              <template #تاریخ="{ item }">
                <td>
                  <span class="pl-muted">{{ get_date_time(item.created_at) }}</span>
                </td>
              </template>

              <template #عملیات="{ item }">
                <td class="pl-ops-cell">
                  <div class="pl-ops">
                    <button
                      type="button"
                      class="pl-btn pl-btn--sm pl-btn--primary"
                      @click="change_status(item, '1')"
                    >
                      <CIcon name="iconCheck"/>
                      <span>انتشار</span>
                    </button>
                  </div>
                </td>
              </template>
            </CDataTableFixed>
          </CTab>
        </CTabs>
      </div>
    </div>

    <CModal
      :show.sync="import_comment_modal"
      :no-close-on-backdrop="false"
      :centered="true"
      size="lg"
      title="دریافت کامنت از سایت دیگر"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CInput
              v-if="import_comments.length == 0"
              v-model="site_link"
              label="لینک محصول"
            />
          </CCol>
          <CCol col="12">
            <CDataTableFixed
              v-if="import_comments.length > 0"
              class="pl-table"
              :items="import_comments"
              :fields="import_comments_field"
              :items-per-page="20"
              hover
              sorter
              pagination
            >
              <template #row="{ item, index }">
                <td>
                  <input type="checkbox" v-model="import_comment_checkbox" :value="index"/>
                </td>
              </template>

              <template #کاربر="{ item }">
                <td>
                  <CInput v-model="item.author"/>
                </td>
              </template>

              <template #تاریخ="{ item }">
                <td>
                  <CInput v-model="item.datePublished"/>
                </td>
              </template>

              <template #متن="{ item }">
                <td>
                  <CTextarea v-model="item.description"/>
                </td>
              </template>
            </CDataTableFixed>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <button
          v-if="import_comments.length == 0"
          type="button"
          class="pl-btn pl-btn--primary"
          @click="import_comment_data()"
        >
          دریافت کامنت‌ها
        </button>
        <button
          v-if="import_comments.length != 0"
          type="button"
          class="pl-btn pl-btn--primary"
          @click="insert_imported_comment()"
        >
          <CIcon name="iconCheck"/>
          <span>افزودن کامنت‌ها</span>
        </button>
        <button
          type="button"
          class="pl-btn pl-btn--ghost"
          @click="import_comment_modal = false, import_comments = ''"
        >
          انصراف
        </button>
      </template>
    </CModal>

    <CModal
      :show.sync="reply_comment_modal"
      :no-close-on-backdrop="false"
      :centered="true"
      size="lg"
      title="پاسخ به دیدگاه"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CTextarea
              v-model="reply_comment_text"
              label="متن پاسخ"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <button type="button" class="pl-btn pl-btn--primary" @click="insert_reply_comment()">
          <CIcon name="iconCheck"/>
          <span>پاسخ به کامنت</span>
        </button>
        <button type="button" class="pl-btn pl-btn--ghost" @click="reply_comment_modal = false">
          انصراف
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";

var items_active = [];
var items_deactive = [];
var items_deleted = [];

const fields = [
  {key: 'row', label: '#', _style: 'width:5%'},
  {key: 'کاربر', _style: 'width:10%'},
  {key: 'product', label: 'محصول', _style: 'width:15%'},
  {key: 'دیدگاه', _style: 'width:20%;'},
  {key: 'تاریخ', _style: 'width:10%;'},
  {key: 'عملیات', _style: 'width:10%;'},
];

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      reply_comment_id: 0,
      reply_comment_modal: false,
      reply_comment_text: '',
      import_comment_modal: false,
      site_link: '',
      import_comments: [],
      import_comments_field: [
        {key: 'row', label: '#', _style: 'width:5%'},
        {key: 'کاربر', _style: 'width:10%'},
        {key: 'متن', _style: 'width:30%'},
        {key: 'تاریخ', _style: 'width:10%'}
      ],
      import_comment_checkbox: [],
      name: '',
      product_title: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      items_active: items_active.map((item, id) => {
        return {...item, id}
      }),
      fields,
      items_deactive: items_deactive.map((item, id) => {
        return {...item, id}
      }),
      items_deleted: items_deleted.map((item, id) => {
        return {...item, id}
      }),
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  mounted() {
    this.get_comments();
  },
  watch: {
    '$route.params.cat_id': function (id) {
      this.get_comments();
    }
  },
  methods: {
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    import_comment_data() {
      var self = this;
      let formData = new FormData();
      formData.append("site_link", this.site_link)

      axios.post('/api/admin/product/get_comment_other_site', formData, {}).then(function (response) {
        var contents = response.data;
        self.import_comment_checkbox = []
        self.import_comments = contents;
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    insert_imported_comment() {
      var self = this;
      let formData = new FormData();
      var json = [];
      this.import_comments.forEach(function (val, index) {
        if (self.import_comment_checkbox.includes(index)) {
          json.push(val)
        }
      })
      formData.append("comments", JSON.stringify(json))
      formData.append("product_id", this.$route.params.product_id)

      axios.post('/api/admin/product/insert_imported_comment', formData, {}).then(function (response) {
        self.import_comment_modal = false
        self.get_comments()
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    insert_reply_comment() {
      var self = this;
      let formData = new FormData();

      formData.append("comment_text", this.reply_comment_text)
      formData.append("comment_id", this.reply_comment_id)

      axios.post('/api/admin/product/insert_reply_comment', formData, {}).then(function (response) {
        self.reply_comment_modal = false
        self.get_comments()
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    get_comments() {
      var self = this;
      let formData = new FormData();
      if (this.$route.params.product_id != null) {
        formData.append("product_id", this.$route.params.product_id)
      }
      axios.post('/api/admin/product/product_comments', formData, {}).then(function (response) {
        var contents = response.data;
        self.items_active = contents.comments_active
        self.items_deactive = contents.comments_deactive
        self.items_deleted = contents.comments_deleted

        if (contents.product != null) {
          self.product_title = contents.product.title.title
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    change_status(item, status) {
      let self = this;
      const formData = new FormData();
      let url;
      url = "/api/admin/product/change_product_comment_status";

      formData.append('comment_id', item.id);
      formData.append('comment_status', status);

      axios.post(url, formData, {}).then((res) => {
        self.get_comments();
      })
        .catch(function (error) {
          console.log(error);
        });
    },
  }
}
</script>
